import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';

import {connect} from 'react-redux';

import {updateTargets} from '../reducers/targets';
import {updateBlockDrag} from '../reducers/block-drag';
import {updateMonitors} from '../reducers/monitors';
import {setProjectChanged, setProjectUnchanged} from '../reducers/project-changed';
import {setRunningState, setTurboState, setStartedState} from '../reducers/vm-status';
import {showExtensionAlert} from '../reducers/alerts';
import {updateMicIndicator} from '../reducers/mic-indicator';

/*
 * Higher Order Component to manage events emitted by the VM
 * @param {React.Component} WrappedComponent component to manage VM events for
 * @returns {React.Component} connected component with vm events bound to redux
 */
const vmListenerHOC = function (WrappedComponent) {
    class VMListener extends React.Component {
        constructor (props) {
            super(props);
            bindAll(this, [
                'handleKeyDown',
                'handleKeyUp',
                'handleProjectChanged',
                'handleTargetsUpdate',
                // 'downloadProject',
                // 'uploadFile',
                'onBlockDragUpdate'
            ]);

            this.state = {
                timer: null
            };

            this.props.vm.on('targetsUpdate', this.handleTargetsUpdate);
            this.props.vm.on('MONITORS_UPDATE', this.props.onMonitorsUpdate);
            this.props.vm.on('BLOCK_DRAG_UPDATE', this.onBlockDragUpdate);
            this.props.vm.on('TURBO_MODE_ON', this.props.onTurboModeOn);
            this.props.vm.on('TURBO_MODE_OFF', this.props.onTurboModeOff);
            this.props.vm.on('PROJECT_RUN_START', this.props.onProjectRunStart);
            this.props.vm.on('PROJECT_RUN_STOP', this.props.onProjectRunStop);
            this.props.vm.on('PROJECT_CHANGED', this.handleProjectChanged);
            this.props.vm.on('RUNTIME_STARTED', this.props.onRuntimeStarted);
            this.props.vm.on('PROJECT_START', this.props.onGreenFlag);
            this.props.vm.on('PERIPHERAL_CONNECTION_LOST_ERROR', this.props.onShowExtensionAlert);
            this.props.vm.on('MIC_LISTENING', this.props.onMicListeningUpdate);
        }

        componentDidMount () {
            if (this.props.attachKeyboardEvents) {
                document.addEventListener('keydown', this.handleKeyDown);
                document.addEventListener('keyup', this.handleKeyUp);
            }
            this.props.vm.postIOData('userData', {username: this.props.username});
        }

        componentDidUpdate (prevProps) {
            if (prevProps.username !== this.props.username) {
                this.props.vm.postIOData('userData', {username: this.props.username});
            }

            if (this.props.shouldUpdateTargets && !prevProps.shouldUpdateTargets) {
                this.props.vm.emitTargetsUpdate(false);
            }
        }

        componentWillUnmount () {
            this.props.vm.removeListener('PERIPHERAL_CONNECTION_LOST_ERROR', this.props.onShowExtensionAlert);
            if (this.props.attachKeyboardEvents) {
                document.removeEventListener('keydown', this.handleKeyDown);
                document.removeEventListener('keyup', this.handleKeyUp);
            }
        }

        handleProjectChanged () {
            if (this.props.shouldUpdateProjectChanged && !this.props.projectChanged) {
                this.props.onProjectChanged();
            }
        }

        handleTargetsUpdate (data) {
            if (this.props.shouldUpdateTargets) {
                this.props.onTargetsUpdate(data);
            }
        }

        handleKeyDown (e) {
            if (e.target !== document && e.target !== document.body) return;

            const key = (!e.key || e.key === 'Dead') ? e.keyCode : e.key;
            this.props.vm.postIOData('keyboard', {
                key: key,
                isDown: true
            });

            if (e.keyCode === 32 || (e.keyCode >= 37 && e.keyCode <= 40)) {
                e.preventDefault();
            }
        }

        handleKeyUp (e) {
            const key = (!e.key || e.key === 'Dead') ? e.keyCode : e.key;
            this.props.vm.postIOData('keyboard', {
                key: key,
                isDown: false
            });

            if (e.target !== document && e.target !== document.body) {
                e.preventDefault();
            }
        }

        // downloadProject () {
        //     this.uploadFile();
        //     // const examCard = sessionStorage.getItem('examCard');
        //     // if (examCard === '') {
        //     //     return false;
        //     // }
        //     // const questionId = sessionStorage.getItem('qid');
        //     // // const url = `http://183.162.197.94:9876/competition/commitQues`;
        //     // const url = 'https://ypc.zhongkediman.com/v2/exam/saveDoQuestion';
        //     // // const url = `https://ypc-backstage.zhongkediman.com/v2/doQuestion/saveDoQuestion`;
        //     // this.props.vm.saveProjectSb3().then(content => {
        //     //     this.uploadFile(url, content, questionId, examCard);
        //     // })
        //     //     .catch(error => {
        //     //         console.error('Failed to save project:', error);
        //     //     });
        // }

        // uploadFile (url, blob, questionId, examCard) {
        //     // Step 1: 通知父页面开始保存
        //     const startSavingEvent = {
        //         type: 'scSaving',
        //         detail: {message: 'scratch文件正在保存...', loading: true}
        //     };
        //     window.parent.postMessage(startSavingEvent, '*'); // 通知父页面开始保存
        
        //     // Step 2: 准备 FormData 数据
        //     const formData = new FormData();
        //     formData.append('examCard', examCard); // 用户考试卡号
        //     formData.append('questionSource', 0); // 问题来源（示例：0）
        //     formData.append('questionID', questionId); // 问题 ID
        //     formData.append('questionType', 3); // 问题类型（示例：3）
        //     formData.append('sourceID', questionId); // 来源 ID（示例直接使用 questionId）
        //     formData.append('language', 'scratch'); // 文件语言（scratch）
        //     formData.append('scratchFile', blob, 'filename.sb3'); // 添加文件内容
        
        //     // Step 3: 发起文件上传请求
        //     fetch(url, {
        //         method: 'POST',
        //         // headers: { token: examCard }, // 如果需要在请求头中传递 token，可以取消注释
        //         body: formData
        //     })
        //         .then(response => {
        //             if (!response.ok) {
        //                 throw new Error('Network response was not ok'); // 请求失败抛出异常
        //             }
        //             return response.json(); // 解析响应 JSON
        //         })
        //         .then(data => {
        //             console.log('File uploaded successfully:', data);
        
        //             // Step 4: 通知父页面保存成功
        //             const successEvent = {
        //                 type: 'scSaving',
        //                 detail: {message: 'scratch文件保存成功！', loading: false}
        //             };
        //             window.parent.postMessage(successEvent, '*'); // 通知父页面保存成功
        //         })
        //         .catch(error => {
        //             console.error('Failed to upload file:', error);
        
        //             // Step 5: 通知父页面保存失败
        //             const errorEvent = {
        //                 type: 'scSaving',
        //                 detail: {message: 'scratch文件保存失败！', loading: false}
        //             };
        //             window.parent.postMessage(errorEvent, '*'); // 通知父页面保存失败
        //         });
        // }
        

        onBlockDragUpdate (areBlocksOverGui) {
            // let timer = null;
            clearTimeout(this.state.timer);
            const examCard = sessionStorage.getItem('examCard');
            if (examCard === '') {
                return false;
            }
            const newTimer = setTimeout(() => {
                const startChangeEvent = {
                    type: 'scChange',
                    detail: {message: 'scratch文件有更新', examCard, fileState: true}
                };
                window.parent.postMessage(startChangeEvent, '*'); // 通知父页面开始保存
            }, 500);
            this.setState({timer: newTimer});
            this.props.updateBlockDrag(areBlocksOverGui);
        }

        render () {
            const {
                attachKeyboardEvents,
                projectChanged,
                shouldUpdateTargets,
                shouldUpdateProjectChanged,
                onBlockDragUpdate, // 解构 props，但不传递给 WrappedComponent
                updateBlockDrag, // 解构 props，但不传递给 WrappedComponent
                onGreenFlag,
                onKeyDown,
                onKeyUp,
                onMicListeningUpdate,
                onMonitorsUpdate,
                onTargetsUpdate,
                onProjectChanged,
                onProjectRunStart,
                onProjectRunStop,
                onProjectSaved,
                onRuntimeStarted,
                onTurboModeOff,
                onTurboModeOn,
                onShowExtensionAlert,
                ...props
            } = this.props;
            return <WrappedComponent {...props} />;
        }
    }

    VMListener.propTypes = {
        attachKeyboardEvents: PropTypes.bool,
        onBlockDragUpdate: PropTypes.func.isRequired,
        updateBlockDrag: PropTypes.func.isRequired,
        onGreenFlag: PropTypes.func,
        onKeyDown: PropTypes.func,
        onKeyUp: PropTypes.func,
        onMicListeningUpdate: PropTypes.func.isRequired,
        onMonitorsUpdate: PropTypes.func.isRequired,
        onProjectChanged: PropTypes.func.isRequired,
        onProjectRunStart: PropTypes.func.isRequired,
        onProjectRunStop: PropTypes.func.isRequired,
        onProjectSaved: PropTypes.func.isRequired,
        onRuntimeStarted: PropTypes.func.isRequired,
        onShowExtensionAlert: PropTypes.func.isRequired,
        onTargetsUpdate: PropTypes.func.isRequired,
        onTurboModeOff: PropTypes.func.isRequired,
        onTurboModeOn: PropTypes.func.isRequired,
        projectChanged: PropTypes.bool,
        shouldUpdateTargets: PropTypes.bool,
        shouldUpdateProjectChanged: PropTypes.bool,
        username: PropTypes.string,
        vm: PropTypes.instanceOf(VM).isRequired
    };

    VMListener.defaultProps = {
        attachKeyboardEvents: true,
        onGreenFlag: () => ({})
    };

    const mapStateToProps = state => ({
        projectChanged: state.scratchGui.projectChanged,
        shouldUpdateTargets: !state.scratchGui.mode.isFullScreen && !state.scratchGui.mode.isPlayerOnly &&
            !state.scratchGui.modals.soundRecorder,
        shouldUpdateProjectChanged: !state.scratchGui.mode.isFullScreen && !state.scratchGui.mode.isPlayerOnly,
        vm: state.scratchGui.vm,
        username: state.session && state.session.session && state.session.session.user ?
            state.session.session.user.username : ''
    });

    const mapDispatchToProps = dispatch => ({
        onTargetsUpdate: data => {
            dispatch(updateTargets(data.targetList, data.editingTarget));
        },
        onMonitorsUpdate: monitorList => {
            dispatch(updateMonitors(monitorList));
        },
        updateBlockDrag: areBlocksOverGui => {
            dispatch(updateBlockDrag(areBlocksOverGui));
        },
        onProjectRunStart: () => dispatch(setRunningState(true)),
        onProjectRunStop: () => dispatch(setRunningState(false)),
        onProjectChanged: () => dispatch(setProjectChanged()),
        onProjectSaved: () => dispatch(setProjectUnchanged()),
        onRuntimeStarted: () => dispatch(setStartedState(true)),
        onTurboModeOn: () => dispatch(setTurboState(true)),
        onTurboModeOff: () => dispatch(setTurboState(false)),
        onShowExtensionAlert: data => {
            dispatch(showExtensionAlert(data));
        },
        onMicListeningUpdate: listening => {
            dispatch(updateMicIndicator(listening));
        }
    });

    const mergeProps = (stateProps, dispatchProps, ownProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        onBlockDragUpdate: areBlocksOverGui => {
            if (ownProps.onBlockDragUpdate) {
                ownProps.onBlockDragUpdate(areBlocksOverGui);
            }
            dispatchProps.updateBlockDrag(areBlocksOverGui);
        }
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps,
        {forwardRef: true}
    )(VMListener);
};

export default vmListenerHOC;
